import { shopCLient } from '@/services/axiosConfig'
import { CartRes, ModifyCartItemReq } from './types'

export type ModifyCartItemResp = CartRes

type ModifyCartItem = (isdn: string, req: ModifyCartItemReq) => Promise<ModifyCartItemResp>

export const modifyCartItem: ModifyCartItem = async (isdn, req) => {
  try {
    const res = await shopCLient.post(`/service/modify-cart?isdn=${isdn}`, req)
    return res.data.response
  } catch (e) {
    console.error(e)
  }
}
